/* Adaptive zoom for the Complete-the-look grid (.product__upsell--grid).
   Measures the product's footprint in each photo (vs. its background) and
   zooms in as far as possible without cropping the piece. Padded photos zoom
   up to CAP; photos the product already fills stay at 1. Target frame fill
   comes from the CSS var --zoom-target (mobile/desktop set in upsell-grid.css). */
(function () {
  'use strict';
  var CAP = 1.8;
  var MARGIN = 0.94;
  var SAMPLE = 96;

  function computeZoom(probe, targetFill) {
    var c = document.createElement('canvas');
    c.width = c.height = SAMPLE;
    var ctx = c.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(probe, 0, 0, SAMPLE, SAMPLE);
    var d = ctx.getImageData(0, 0, SAMPLE, SAMPLE).data;
    var pick = function (i, j) {
      var p = (j * SAMPLE + i) * 4;
      return [d[p], d[p + 1], d[p + 2]];
    };
    var corners = [pick(2, 2), pick(SAMPLE - 3, 2), pick(2, SAMPLE - 3), pick(SAMPLE - 3, SAMPLE - 3)];
    var bg = [0, 1, 2].map(function (k) {
      return (corners[0][k] + corners[1][k] + corners[2][k] + corners[3][k]) / 4;
    });
    var minX = SAMPLE, maxX = 0, minY = SAMPLE, maxY = 0, found = false;
    for (var j = 0; j < SAMPLE; j++) {
      for (var i = 0; i < SAMPLE; i++) {
        var p = (j * SAMPLE + i) * 4;
        if (Math.abs(d[p] - bg[0]) + Math.abs(d[p + 1] - bg[1]) + Math.abs(d[p + 2] - bg[2]) > 34) {
          found = true;
          if (i < minX) minX = i;
          if (i > maxX) maxX = i;
          if (j < minY) minY = j;
          if (j > maxY) maxY = j;
        }
      }
    }
    if (!found) return 1;
    var nx = Math.max(Math.abs(minX / SAMPLE - 0.5), Math.abs(maxX / SAMPLE - 0.5));
    var ny = Math.max(Math.abs(minY / SAMPLE - 0.5), Math.abs(maxY / SAMPLE - 0.5));
    var safe = (0.5 / Math.max(nx, ny)) * MARGIN;
    var span = Math.max((maxX - minX) / SAMPLE, (maxY - minY) / SAMPLE);
    return Math.max(1, Math.min(targetFill / span, safe, CAP));
  }

  function apply(img) {
    if (img.dataset.upsellZoom) return;
    img.dataset.upsellZoom = 'pending';
    var grid = img.closest('.product__upsell--grid');
    if (!grid) return;
    var target = parseFloat(getComputedStyle(grid).getPropertyValue('--zoom-target')) || 0.58;
    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onload = function () {
      try {
        var z = computeZoom(probe, target);
        if (z > 1.01) img.style.transform = 'scale(' + z.toFixed(3) + ')';
        img.dataset.upsellZoom = z.toFixed(3);
      } catch (e) {
        img.dataset.upsellZoom = 'error';
      }
    };
    probe.onerror = function () {
      img.dataset.upsellZoom = 'error';
    };
    probe.src = img.currentSrc || img.src;
  }

  function whenLoaded(img) {
    if (img.complete && img.naturalWidth) {
      apply(img);
    } else {
      img.addEventListener('load', function () { apply(img); }, { once: true });
    }
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.product__upsell--grid .product-upsell__image img').forEach(whenLoaded);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  /* theme editor re-renders sections without a full page load */
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
